export type ChartScaleMode = "fixed" | "linear-auto" | "logarithmic";

export const hasValuesOutsideRange = (
  values: number[],
  range?: { min: number; max: number },
) => {
  if (!range || values.length === 0) return false;
  return values.some((value) => value < range.min || value > range.max);
};

export const canUseLogarithmicScale = (values: number[]) =>
  values.length > 0 && values.every((value) => value > 0);
